export default "__VITE_ASSET__CvF3nEbw__"